import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccessService } from '../../access.service';
import { Access, User } from '../../../auth/user.model';
import { StorageService } from '../../../storage/storage.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-access-invitation',
  templateUrl: './access-invitation.component.html',
  styleUrls: ['./access-invitation.component.css']
})
export class AccessInvitationComponent implements OnInit {

  newMemberInviteFormGroup: FormGroup;
  user: User;
  access: Access;
  currentProject: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public projectId: number,
    public dialogRef: MatDialogRef<AccessInvitationComponent>,
    private formBuilder: FormBuilder,
    private accessService: AccessService,
    private authentication: AuthService
  ) { }

  ngOnInit() {
    this.user = this.authentication.getUser();
    this.newMemberInviteFormGroup = this.formBuilder.group({
      'email' : [null, Validators.required],
      'permission' : [null, Validators.required]
    });
    this.newMemberInviteFormGroup.valueChanges.subscribe(val => {
    });
  }

  onSubmitMemberInvitation(event: Event) {
    const data = {
      email: this.newMemberInviteFormGroup.value.email,
      permissionId: this.newMemberInviteFormGroup.value.permission
    };

    this.accessService.inviteNewMember(this.user.token, data).subscribe((response: Access) => {
      this.dialogRef.close();
    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
